export default "<span class=\"content\">\n</span>"